import { flyers as initialState } from "flux/initialState";
import { flyers as actions } from "flux/actions";

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.SET_CURRENT_FLYER: {
      const { flyer } = action.payload;
      return {
        ...state,
        current: flyer,
      };
    }
    case types.SET_CURRENT_FLYER_GIBS: {
      const { flyerGibs, flyerGibsChildIdsMap } = action.payload;
      return { ...state, flyerGibs, flyerGibsChildIdsMap };
    }
    case types.SET_CURRENT_FLYER_STORES: {
      const { storesList } = action.payload;
      return { ...state, currentFlyerStores: storesList };
    }
    // case types.SET_NEARBY_FLYERS: {
    //   const { flyersList } = action.payload;
    //   return { ...state, nearbyFlyers: flyersList };
    // }
    case types.SET_FLYER_STORES: {
      const { flyerId, storesList, modalityFetchStore } = action.payload;
      if (storesList.length > 0) {
        const storeListObj = storesList.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
        return {
          ...state,
          list: {
            ...state.list,
            [flyerId]: {
              ...state.list[flyerId],
              stores: storeListObj,
              fetchedStores: modalityFetchStore,
            },
          },
        };
      }
      return {
        ...state,
        list: {
          ...state.list,
          [flyerId]: {
            ...state.list[flyerId],
            fetchedStores: modalityFetchStore,
          },
        },
      };
    }
    case types.RESET: {
      const { resetState } = action.payload;
      return { ...resetState, fetched: true };
    }
    case types.SET_FLYERS_PAGE_CONTENT_HEIGHT: {
      const { flyersPageContentHeight } = action.payload;
      return { ...state, flyersPageContentHeight };
    }
    case types.UPDATE_FLYERS_BY_LOCATION: {
      const { flyers, location } = action.payload;
      const { list: flyersList } = flyers;
      return {
        ...state,
        list: flyersList,
        fetchedLocation: location,
      };
    }

    case types.SET_CURRENT_FLYER_STORE_OPENING_INFOS: {
      const { storeId, storeHours } = action.payload;
      const newState = { ...state };
      const storeIndex = newState.currentFlyerStores.findIndex(
        (store) => store.id === storeId
      );

      newState.currentFlyerStores[storeIndex] = {
        ...newState.currentFlyerStores[storeIndex],
        storeHours,
      };

      return { ...newState };
    }

    default:
      return state;
  }
}
